import type { ApiNotificationSubscriptionsLayout } from '@app/packages/internalApi/types'
import { createInternalApiAction, endpoint } from '@app/packages/internalApi/utils'

export const getNotificationSubscriptionsLayouts = (account_type?: 'parent' | 'sitter') =>
  createInternalApiAction('getNotificationSubscriptionsLayouts', dispatch =>
    dispatch<{ data: ApiNotificationSubscriptionsLayout }>({
      method: 'GET',
      endpoint: endpoint('/internal/api/v1/notification_subscriptions_layouts', { account_type }),
    })
  )
